import React from 'react'

import format from '../../../../services/format'

import EmptyText from './EmptyText'

export default ({ address, hideIfEmpty }) => {
  const populated = (() => {
    if (!address) return false
    if (!address.line1 && !address.city && !address.state && !address.zip) return false

    return true
  })()

  if (hideIfEmpty && !populated) return <EmptyText />

  const csz = format.cityStateZip(address)

  return (
    <>
      <div className="form-text">
        {!populated ? (
          <EmptyText />
        ) : (
          <>
            {address.line1 && <div>{address.line1}</div>}
            {csz && <div>{csz}</div>}
          </>
        )}
      </div>
    </>
  )
}
